export default [
    {
        key: 'provider',
        label: 'Provider',
        components: [
            {
                type: 'select',
                input: true,
                key: 'provider',
                label: 'Provider',
                placeholder: 'Select your Postcode API provider',
                weight: 0,
                tooltip: 'Which Postcode API service should be used.',
                valueProperty: 'value',
                dataSrc: 'values',
                data: {
                    values: [
                        {
                            label: 'postcode.nl',
                            value: 'postcodenl',
                        },
                    ]
                },
                validate: {
                    required: true,
                },
            },
            {
                type: 'textfield',
                input: true,
                key: 'providerOptions.apiBaseUrl',
                label: 'API base URL',
                placeholder: 'Enter the Postcode API base URL',
                weight: 10,
                tooltip: 'E.g. https://api.postcode.eu/nl/v1/addresses/postcode',
                validate: {
                    required: true,
                },
                conditional: {
                    json: { '===': [{ var: 'data.provider' }, 'postcodenl'] },
                },
            },
        ]
    }
];
